import React from "react";
import styles from "./ConfirmCancelEqueueAlert.style";
import {Alert} from "@vkontakte/vkui";
import {connect} from "react-redux";
import {setActiveAlert} from "../../redux/actions/alertsActions";
import {cancelEqueueStart} from "../../redux/actions/equeuesActions";
import {selectSlot} from "../../redux/actions/datesActions";
import {hideEqueuesSnackBar} from "../../redux/actions/snackbarsActions";

const ConfirmCancelEqueueAlert = ({hideConfirmCancelEqueueAlert, cancelEqueue, selectedEqueue,
                                      clearSlot,hideSnackBar}) => {

    const onCancelButtonClick = () => {
        const [extId, eserviceId] = getRequestAttributes();
        cancelEqueue(extId, eserviceId);
        hideConfirmCancelEqueueAlert();
    }

    const getRequestAttributes = () => {
        const eserviceId = selectedEqueue.detail.eventAttributes[findEServiceId(selectedEqueue.detail.eventAttributes)].value;
        const extId = selectedEqueue.extId;
        return [extId, eserviceId]
    }

    const findEServiceId = (array) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i].name === "eserviceId") {
                return i;
            }
        }
        return -1;
    }
    return (
        <Alert
            actions={[{
                title: 'Нет',
                autoclose: true,
            }, {
                title: 'Да,  отменить',
                autoclose: true,
                action: () => onCancelButtonClick(),

            }]}
            onClose={() => {
                hideConfirmCancelEqueueAlert();
                clearSlot();
                hideSnackBar();
            }}
        >
            <h2 style={styles.black}>Отмена записи</h2>
            <p style={styles.gray}>Вы уверены, что хотите отменить запись к врачу?</p>
        </Alert>
    )
}

const mapStateToProps = (state) => {
    return {
        selectedEqueue: state.selectedEqueue.selectedEqueue,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        hideConfirmCancelEqueueAlert: () => dispatch(setActiveAlert(null)),
        cancelEqueue: (extId, eserviceId) => dispatch(cancelEqueueStart(extId, eserviceId)),
        clearSlot: () => dispatch(selectSlot(null)),
        hideSnackBar: () => dispatch(hideEqueuesSnackBar())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmCancelEqueueAlert);
